module.exports = __webpack_public_path__ + "img/icon.2f23bf3a.png";